import React, { useRef, useState, useEffect } from 'react';

const DateSelect = ({ selectedDate, onDateSelect }) => {
  const dateContainerRef = useRef(null);
  const todayRef = useRef(null); // Ref to scroll today's date into view

  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth()); // Default to current month
  const [selectedYear] = useState(2025);
  const [dates, setDates] = useState([]);

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  let isDown = false;
  let startX;
  let scrollLeft;

  const handleMouseDown = (e) => {
    isDown = true;
    startX = e.pageX - dateContainerRef.current.offsetLeft;
    scrollLeft = dateContainerRef.current.scrollLeft;
    dateContainerRef.current.style.cursor = 'grabbing';
  };

  const handleMouseUp = () => {
    isDown = false;
    dateContainerRef.current.style.cursor = 'grab';
  };

  const handleMouseLeave = () => {
    isDown = false;
    dateContainerRef.current.style.cursor = 'grab';
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - dateContainerRef.current.offsetLeft;
    const walk = x - startX;
    dateContainerRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMonthChange = (e) => {
    setSelectedMonth(parseInt(e.target.value));
  };

  const handleDateClick = (day) => {
    const date = new Date(selectedYear, selectedMonth, day);
    const formattedDate = date.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    onDateSelect(formattedDate);
  };

  const generateDates = (month, year) => {
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const today = new Date();
    const todayDay = today.getDate();
    const todayMonth = today.getMonth();
    const todayYear = today.getFullYear();

    const newDates = [];

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);
      const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });

      const isToday =
        day === todayDay && month === todayMonth && year === todayYear;

      const dateString = date.toISOString().split('T')[0];
      const isSelected = selectedDate === dateString;

      newDates.push({ day, weekday, isToday, isSelected, dateString });
    }

    setDates(newDates);
  };

  useEffect(() => {
    generateDates(selectedMonth, selectedYear);
  }, [selectedMonth, selectedYear, selectedDate]); // Add selectedDate to dependencies

  useEffect(() => {
    // Scroll to today's date after DOM updates
    if (todayRef.current) {
      todayRef.current.scrollIntoView({ behavior: 'smooth', inline: 'start' });
    }
  }, [dates]);

  return (
    <div className="select-datelist">
      <div className="calendar-box d-flex justify-content-between align-items-center mb-3">
        <label>Select Date</label>
        <div>
          <select
            id="monthYearSelect"
            className="form-select d-inline w-auto"
            value={selectedMonth}
            onChange={handleMonthChange}
          >
            {months.map((monthName, index) => (
              <option key={index} value={index}>
                {monthName} 2025
              </option>
            ))}
          </select>
        </div>
      </div>

      <div
        className="d-flex overflow-auto grab"
        id="dateContainer"
        ref={dateContainerRef}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
        style={{ cursor: 'grab' }}
      >
        {dates.map((date, index) => (
          // <div
          //   key={index}
          //   className="text-center date-box"
          //   ref={date.isToday ? todayRef : null}
          //   onClick={() => handleDateClick(date.day)}
          //   style={
          //     date.isSelected
          //       ? { background: '#28a745', color: '#fff', borderRadius: '8px' }
          //       : date.isToday
          //       ? { background: '#6a49f2', color: '#fff', borderRadius: '8px' }
          //       : {}
          //   }
          // >
            <div
            key={index}
            className={`text-center date-box 
              ${date.isSelected ? 'selected' : ''} 
              ${!date.isSelected && date.isToday ? 'today' : ''}`}
            ref={date.isToday ? todayRef : null}
            onClick={() => handleDateClick(date.day)}
          >
            
            <div className="inner-box">
              <div>{date.weekday}</div>
              <div>{date.day}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DateSelect;